function Error() {
  return (
    <div className="text-center pt-[20%] p-2">
      <h1>404 - Page Not Found</h1>
      <p>Oohooo! ...the page you're looking for doesn't exist.</p>
    </div>
  );
}

export default Error;
